import { render, staticRenderFns } from "./OnBoardingLayout.vue?vue&type=template&id=2d800f13&scoped=true&"
import script from "./OnBoardingLayout.vue?vue&type=script&lang=js&"
export * from "./OnBoardingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d800f13",
  null
  
)

export default component.exports